<template>
   <vx-card :title="id === null ? 'Cadastrar Professor' : 'Editar Professor'">
    <vs-tabs :color="colorx" v-model="tabIndex">
      <vs-tab label="Dados Básicos">
        <TeacherForm :services="services"
                         :teacherId="id"
                         :teacherEntity="teacherEntity"
                         @update-data="handleUpdateDataTeacher"></TeacherForm>
      </vs-tab>
      <vs-tab label="Endereço" :disabled="isTabEnabled">
        <Address :services="services" :people_id="teacherEntity.people_id" v-if="teacherEntity.people_id"/>
      </vs-tab>
      <vs-tab label="Telefone" :disabled="isTabEnabled">
        <Phone :services="services" :people_id="teacherEntity.people_id" v-if="teacherEntity.people_id"/>
      </vs-tab>
      <vs-tab label="Email" :disabled="isTabEnabled">
        <Email :services="services" :people_id="teacherEntity.people_id" v-if="teacherEntity.people_id"/>
      </vs-tab>
      <vs-tab label="Entidade de classe" :disabled="isTabEnabled">
        <ClassEntity :services="services"
                     :teacherId="id"
                     :people_id="teacherEntity.people_id" v-if="teacherEntity.people_id"/>
      </vs-tab>
      <!--
      <vs-tab label="Dados Bancários" :disabled="isTabEnabled">
        <Bank :services="services"
              :serviceDelegate="services.teacherService"
              :entityId="id"
              :people_id="teacherEntity.people_id"
              v-if="teacherEntity.people_id"/>
      </vs-tab>
      -->
      <vs-tab label="Modalidades" :disabled="isTabEnabled">
        <Modality :services="services"
                  :serviceDelegate="services.teacherService"
                  :entityId="id"
                  :people_id="teacherEntity.people_id" v-if="teacherEntity.people_id"/>
      </vs-tab>
      <vs-tab label="Imagens" :disabled="isTabEnabled">
        <Images :serviceDelegate="services.teacherService"
                :people_id="teacherEntity.people_id"
                :entityId="teacherEntity.id"
                :imagesList="teacherEntity.images"
                target="teachers"
                hint="Tamanho recomendado: mínimo 600×600px (quadrado ou retrato), rosto centralizado — usada como foto do professor nas páginas de clube e aula."
                v-if="teacherEntity.people_id"/>
      </vs-tab>
      <!-- <vs-tab label="Documentos" :disabled="isTabEnabled">
        <Document :services="services" personType="PJ" />
      </vs-tab> -->
    </vs-tabs>
  </vx-card>
</template>

<script>
import Datepicker from 'educatena-vuejs-datepicker'
import { ptBR } from 'educatena-vuejs-datepicker/dist/locale'
import vSelect from 'vue-select'
import Constants from '../../../../util/Constants'

import FederationUnitService from '@/services/api/FederationUnitService'
import CityService from '@/services/api/CityService'
import TeacherService from '@/services/api/TeacherService'
import EmailTypeService from '@/services/api/EmailTypeService'
import AddressService from '@/services/api/AddressService'
import AddressTypeService from '@/services/api/AddressTypeService'
import EmailService from '@/services/api/EmailService'
import FinancialInstitutionService from '@/services/api/FinancialInstitutionService'
import BankDetailService from '@/services/api/BankDetailService'
import PhoneTypeService from '@/services/api/PhoneTypeService'
import PhoneService from '@/services/api/PhoneService'
import AreaCodeService from '@/services/api/AreaCodeService'
import ModalityService from '@/services/api/ModalityService'
import DocumentTypeService from '@/services/api/DocumentTypeService'
import DocumentPeopleService from '@/services/api/DocumentPeopleService'
import ClassEntityService from '@/services/api/ClassEntityService'

import TeacherForm from '../tabs/TeacherForm'
import Address from '../tabs/Address'
import Email from '../tabs/Email'
import Bank from '../tabs/Bank'
import Phone from '../tabs/Phone'
//import Document from '../tabs/Document'
import Modality from '../tabs/Modality'
import Responsable from '../tabs/Responsable'
import ClassEntity from '../tabs/ClassEntity'
import Images from '../tabs/Images'

export default {
  components: {
    Datepicker,
    vSelect,
    Address,
    Email,
    Bank,
    Phone,
    Document,
    Modality,
    Responsable,
    TeacherForm,
    Constants,
    ClassEntity,
    Images,
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    tabIndex: 0,
    teacherEntity: {
      id: null,
      people_id: null,
      name: null,
      document: null,
      birthdate: null,
      email: null,
      status: null,
      description: null,
      images: [],
    },
    services: {
      federationUnitService: null,
      cityService: null,
      peopleService: null,
      teacherService: null,
      emailTypeService: null,
      addressService: null,
      addressTypeService: null,
      emailService: null,
      financialInstitutionService: null,
      bankDetailService: null,
      phoneTypeService: null,
      phoneService: null,
      areaCodeService: null,
      documentTypeService: null,
      documentPeopleService: null,
      modalityService: null,
      classEntityService: null,
      availableScheduleService: null,
    },
  }),
  methods: {
    loadData(){
      this.$vs.loading()
      this.services.teacherService.read(this.id).then(
        data => {

          this.teacherEntity.id = data.id
          this.teacherEntity.people_id = data.people_id
          this.teacherEntity.name = data.people.name
          this.teacherEntity.document = data.people.document
          this.teacherEntity.email = data.people.email
          this.teacherEntity.birthdate = data.people.birthdate
          //this.$utils.format.date(date)
          //this.teacher.status = data.status
          this.teacherEntity.description = data.description
          this.teacherEntity.images = data.images

          this.$vs.loading.close()
        },
        error => {this.$vs.loading.close()}
      )
    },
    handleUpdateDataTeacher(data){
      if(!this.id){ //Include
        this.$router.push(`/teachers/${data.id}/edit`)
        this.teacherEntity = data
        /*
        this.$router.push({
          path: `/legal_entities/${data.id}/edit`,
          query: { refresh: new Date().getTime() }, // Parâmetro único
        })
          */
      }
    },
  },
  computed: {
    isTabEnabled() {
      return this.id === null
    }
  },
  mounted() {
    if(this.id){
      this.loadData()
    }
  },
  beforeMount() {
    this.services.federationUnitService = FederationUnitService.build(this.$vs)
    this.services.cityService = CityService.build(this.$vs)
    this.services.teacherService = TeacherService.build(this.$vs)
    this.services.emailTypeService = EmailTypeService.build(this.$vs)
    this.services.addressService = AddressService.build(this.$vs)
    this.services.addressTypeService = AddressTypeService.build(this.$vs)
    this.services.emailService = EmailService.build(this.$vs)
    this.services.financialInstitutionService = FinancialInstitutionService.build(this.$vs)
    this.services.bankDetailService = BankDetailService.build(this.$vs)
    this.services.phoneTypeService = PhoneTypeService.build(this.$vs)
    this.services.phoneService = PhoneService.build(this.$vs)
    this.services.areaCodeService = AreaCodeService.build(this.$vs)
    this.services.documentTypeService = DocumentTypeService.build(this.$vs)
    this.services.documentPeopleService = DocumentPeopleService.build(this.$vs)
    this.services.modalityService = ModalityService.build(this.$vs)
    this.services.classEntityService = ClassEntityService.build(this.$vs)
  }
}
</script>
